<template>
    <div class="text-center" :class="{'fullscrean': fullscrean}">
      <div>
        <div class="dot-flashing"></div>
        <div class="small text-theme font-weight-bold mt-3" v-show="text">{{text}}</div>
      </div>
    </div>
</template>

<script>
    export default {
      name: "loading",
      props: ['fullscrean', 'text']
    }
</script>

<style scoped>
  .fullscrean {
    position: absolute;
    top: 35%;
    left: 50%;
    transform: translateX(-50%);
  }

  .dot-flashing {
    margin: auto;
    position: relative;
    width: 12px;
    height: 12px;
    border-radius: 999px;
    animation: dotFlashing 1s infinite linear alternate;
    animation-delay: .5s;
  }

  .dot-flashing::before, .dot-flashing::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
  }

  .dot-flashing::before {
    left: -15px;
    width: 12px;
    height: 12px;
    border-radius: 999px;
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 0s;
  }

  .dot-flashing::after {
    left: 15px;
    width: 12px;
    height: 12px;
    border-radius: 999px;
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 1s;
  }

  .dot-flashing, .dot-flashing::before, .dot-flashing::after {
    background-color: var(--primary);
    color: var(--primary);
  }

  @keyframes dotFlashing {
    0% {
      background-color: var(--primary);
    }
    50%,
    100% {
      background-color: rgba(199, 244, 123, 0.2);
    }
  }

</style>
